// extracted by mini-css-extract-plugin
export default {"city":"City_city__Gs9Ro","row":"City_row__qzLZF"};